module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_as_competitor":"Add this competitor","already_competitor":"Already added"},"fr":{"add_as_competitor":"Ajouter ce concurrent","already_competitor":"Concurrent déjà ajouté"},"de":{"add_as_competitor":"Fügen Sie diesen Konkurrenten hinzu","already_competitor":"Wettbewerber bereits hinzugefügt"}}')
  delete Component.options._Ctor
}
